import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common';

const states: Ng1StateDeclaration[] = [
    {
        name: 'thermoPackage',
        url: '/thermoPackage/:name',
        component: 'wtThermoPackageState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        data: {
            visible: false,
            isAuthenticated: true,
            isConnected: true,
            icon: 'fa-flask',
            displayName: 'Thermo package',
            editRoles: [Roles.engineer],
            editButtonVisibility: () => false,
            breadcrumbs: {
                level3StateName: 'moreTools.thermoPackages',
                level4: ''
            }
        }
    }];

export default states;